<div class="search" [ngClass]="{'open': isOpen}">
  <input type="search" class="search-box" />
  <span class="search-button" (click)="toggle()">
    <span class="search-icon"></span>
  </span>
</div>
